export default "__VITE_ASSET__DqEQBPdJ__"